<template>
<div>
	
</div>
</template>

<script>

import { eventBus } from './../main'

export default {
	created(){

		if (this.$gstate.getInputAllowed()) 
		{
			this.$router.push("/transaction");
		} else {
			eventBus.$emit('paramHandlerFail');

			this.$gstate.log("Make sure you've defined the new route in App.vue");
			this.$gstate.log(this.$route.params);
			
			this.$gstate.redirectHome('', 0, 'paramHandlerFail');
		}
		
	}
}

</script>

